import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import type { RootState } from "../redux/reducers/session/state";

interface FooterLink {
  text: string;
  onClick: () => void;
}

const legalPageSlugs = ["notice", "cookies", "privacy", "terms", "disclaimer"] as const;

const useFooterContent = (): FooterLink[] => {
  const referrerType = useSelector((state: RootState) => state?.sessionState?.user?.referrerType);

  const { t: tFooter } = useTranslation("footer");
  const navigate = useNavigate();

  const legalPageLinks: FooterLink[] = legalPageSlugs.map((slug) => ({
    text: tFooter(slug),
    onClick: () => navigate(`/legal/${slug}`),
  }));

  const partnerLinks: FooterLink[] = [
    {
      text: tFooter("tncReferrer"),
      onClick: () => navigate("/legal/tnc-referrer"),
    },
    {
      text: tFooter("tncPartner"),
      onClick: () => navigate("/legal/tnc-partner"),
    },
  ];

  const distributorLinks: FooterLink[] = [
    {
      text: tFooter("tncDistributor"),
      onClick: () => navigate("/legal/tnc-distributor"),
    },
  ];

  return [...legalPageLinks, ...(referrerType !== "DISTRIBUTOR" ? partnerLinks : distributorLinks)];
};

export default useFooterContent;
